<template>
  <div class="relative flex w-full flex-row items-center justify-between">
    <div
      class="flex"
      :class="{
        invisible: !showBackButton && !previousRoute
      }"
    >
      <VButton type="chip" title="Voltar" :callback="goBack" />
    </div>

    <h1
      :class="{
        invisible: title === undefined,
        'skeleton h-4 w-[120px] rounded': isLoading
      }"
      class="font-bold text-primary"
    >
      {{ title }}
    </h1>

    <div
      class="flex flex-row items-center gap-2"
      :class="{
        invisible: !showToggle
      }"
    >
      <IconCamera
        class="h-5 w-5 text-primary"
        :class="{
          selected: !isExternalSensorSelected
        }"
      />

      <SwitchInput v-model="isExternalSensorSelected" />

      <IconBarcode
        class="h-5 w-5 text-primary"
        :class="{
          selected: isExternalSensorSelected
        }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useEventBus } from '@/plugins/eventBus/eventBus'
import { ScanInputType, useAppStore } from '@/stores/app.store'
import { IconBarcode, IconCamera } from '@tabler/icons-vue'
import { computed, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import VButton from '../Button/VButton.vue'
import SwitchInput from '../SwitchInput/SwitchInput.vue'

const props = defineProps<{
  showBackButton?: boolean
  showToggle?: boolean
  title?: string | null
  isLoading?: boolean
  preventGoBack?: boolean
}>()

const emit = defineEmits(['goBack'])
const eventBus = useEventBus()
const appStore = useAppStore()
const router = useRouter()
const route = useRoute()

const isExternalSensorSelected = ref(appStore.scanInputType === ScanInputType.EXTERNAL_SENSOR)
const previousRoute = computed(() => route.meta.previousRoute as string)

watch(isExternalSensorSelected, (value) => {
  appStore.actions.setScanInputType(value ? ScanInputType.EXTERNAL_SENSOR : ScanInputType.CAMERA)
})

const goBack = async () => {
  emit('goBack')
  if (props.preventGoBack) return
  router.push({
    name: previousRoute.value
  })
}

onMounted(() => {
  if (props.showBackButton) {
    eventBus.on('goBack', goBack)
  } else {
    eventBus.off('goBack')
  }
})
</script>

<style scoped lang="scss">
.selected {
  @apply text-yellow-500;
}
</style>
